/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export enum BaseServiceRegion {
  au = 'au',
  uk = 'uk',
  us = 'us',
}
